import cn from "classnames";
import React from "react";
import TransferNodeSvg from "./../../components/svgComponents/TransferNodeSvg";
import NodeIcon from "./../../assets/icons/NodeIcon.png";

const NodeToTransfer = ({ nodeName, setCurrentNode, currentNode }) => {
  return (
    <button
      className={cn(
        "rounded-2xl bg-white px-6 pt-6 pb-8 shadow-smallShadow snap-center dark:bg-[#232234]",
        {
          "border border-deepBlue": currentNode === nodeName,
        }
      )}
      type="button"
      onClick={() => {
        setCurrentNode(nodeName);
      }}
    >
      <article className="flex flex-col gap-6">
        <div className="mb-6 w-[63px] h-[52px]">
          <img src={NodeIcon} alt="" className="w-full" />
        </div>

        <h3 className="font-semibold text-xl leading-6 text-black dark:text-white text-left">{`Node ${nodeName}`}</h3>
      </article>
    </button>
  );
};

export default NodeToTransfer;
